import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'

/**
 * Handles push notifications for pending metric value approvals
 */
var pendingMetricValueApprovals = {
	listenForPushNotification: function(context, callback) {
		const socketListener = ({numPending, action}, opts) => {
			if (_.get(opts, 'push')) { // websocket push event - reload the alerts

				if (action !== 'create') {
					Backbone.trigger('change:numPending', {numPending})
				} else {
					$.get('api/scorecards/metric-approval-count', newData => {
						Backbone.trigger('change:numPending', {numPending: newData.numPending})
						callback(newData)
					})
				}
			}
		}

		Backbone.on('change:numPending', socketListener, context)
	},

	stopListeningForPushNotification: function(context) {
		Backbone.off('change:numPending', null, context)
	}
}

Backbone.on('load', function(data) {
	if (data.numPending) {
		pendingMetricValueApprovals.numPending = data.numPending
	}
})

Backbone.on('change:numPending', ({numPending}) => {
	pendingMetricValueApprovals.numPending = numPending
})


export default pendingMetricValueApprovals

pendingMetricValueApprovals.__filename__ = 'home/metric-approvals/pending-metric-value-approvals.js'
